<template>
  <div>
    <Navigation />
    <div class="logged-in participant-layout">
      <div class="has-text-centered">
        <br>
        <h1 class="is-size-4">This account is no longer active.</h1>
      </div>
    </div>
  </div>
</template>

<script>
import Navigation from '@/components/navigation/Navigation'

export default {
  name: 'Deactivated',
  components: {
    Navigation
  }
}
</script>
